/**
 * User-facing copy for the offer product picker (Create / Edit offer).
 * This repo has no i18n framework yet, so the copy lives here instead of
 * inline in the components.
 */
export const offerProductStrings = {
  billingPeriodNotSupported: 'Billing period not supported in offers yet',
  trialNotSupported: 'Trials are not available for this product yet',
};
